import { render } from "./IconRoadBike.vue?vue&type=template&id=f3073024"
import script from "./IconRoadBike.vue?vue&type=script&lang=js"
export * from "./IconRoadBike.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__